import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import React from "react";

import { BigAndThreeSmallRectangularLayout } from "./big-and-three-small";
import { ThreeSmallAndBigRectangularLayout } from "./three-small-and-big";
import { splitArrayIntoSubArraysOfSize } from "../../../../../utils/js/missing-js-parts";
import { StoriesOverviewSectionType } from "@swo/storefront";
import { ExpandedStoryTeaser } from "../../../../../layouts/stories/stories-overview-page/stories-overview-page-layout";

export const StoriesOverviewTeasers: ReactTFC<{
  teasers: Array<ExpandedStoryTeaser>;
  layout: StoriesOverviewSectionType["layout"];
}> = props => {
  const { teasers, layout } = props;

  return (
    <div>
      {splitArrayIntoSubArraysOfSize(teasers, 4).map((t, idx) =>
        layout === "1 big and 3 small teasers" ? (
          <BigAndThreeSmallRectangularLayout big={t[0]!} smallTeasers={t.slice(1, 4)} key={idx} />
        ) : (
          <ThreeSmallAndBigRectangularLayout smallTeasers={t.slice(0, 3)} big={t[3]!} key={idx} />
        ),
      )}
    </div>
  );
};
